import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// UI (bundled)
import arUi from "./locales/ar/ui.json";
import deUi from "./locales/de/ui.json";
import enUi from "./locales/en/ui.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { ui: enUi },
      de: { ui: deUi },
      ar: { ui: arUi },
    },
    ns: ["ui"],
    defaultNS: "ui",
    lng: "ar",
    fallbackLng: "en",
    partialBundledLanguages: true,
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
